import styled, { css } from 'styled-components';
import { P, fs, radius, shadow, eyebrow, ease, fontSans, tint, tintB, tintT } from '../../theme/tokens';

const AGENDA_BP = 640;

export const Root = styled.div`
  container-type: inline-size;
  transition: opacity 150ms ${ease};
  opacity: ${(p) => (p.$stale ? 0.55 : 1)};
`;

export const Scroll = styled.div`
  overflow-x: auto;

  @container (max-width: ${AGENDA_BP}px) {
    display: none;
  }
`;

export const Table = styled.table`
  width: 100%;
  min-width: ${(p) => p.$minWidth}px;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: ${fs.xs}px;
`;

const todayCol = css`
  background: ${(p) => (p.$today ? P.rowHover : 'transparent')};
`;

export const Th = styled.th`
  ${eyebrow}
  ${todayCol}
  width: ${(p) => (p.$width ? `${p.$width}px` : 'auto')};
  padding: 10px 12px;
  text-align: left;
  white-space: nowrap;
  border-bottom: 1px solid ${P.line};
  color: ${(p) => (p.$today ? P.navy : P.subtle)};

  small {
    display: block;
    margin-top: 2px;
    font-family: inherit;
    font-size: ${fs.xs}px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
    color: ${(p) => (p.$today ? P.navyInk : P.muted)};
  }
`;

export const RowHead = styled.th`
  padding: 12px;
  text-align: left;
  vertical-align: top;
  border-bottom: 1px solid ${P.line};
  font-size: ${fs.sm}px;
  font-weight: 700;
  color: ${P.ink};
`;

export const RowLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    flex: 0 0 8px;
    border-radius: 50%;
    background: ${(p) => p.$color};
  }
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Td = styled.td`
  ${todayCol}
  height: 64px;
  padding: 8px 6px;
  vertical-align: top;
  border-bottom: 1px solid ${P.line};
`;

export const EmptyCell = styled.td`
  padding: 28px 12px;
  text-align: center;
  font-size: ${fs.sm}px;
  color: ${P.subtle};
`;

export const Stack = styled.div`
  display: grid;
  gap: 6px;
`;

export const Chip = styled.button`
  display: block;
  width: 100%;
  min-width: 0;
  padding: 6px 9px;
  border: 1px solid ${(p) => (p.$muted ? P.line : tintB(p.$color))};
  border-radius: ${radius.md}px;
  background: ${(p) => (p.$muted ? P.bgSubtle : tint(p.$color))};
  color: ${(p) => (p.$muted ? P.muted : tintT(p.$color))};
  font-family: inherit;
  font-size: ${fs.xs}px;
  line-height: 1.4;
  text-align: left;
  cursor: pointer;
  transition: box-shadow 150ms ${ease}, transform 150ms ${ease};

  &:hover {
    box-shadow: ${shadow.md};
    transform: translateY(-1px);
  }
  &:focus-visible {
    outline: 2px solid ${P.navy};
    outline-offset: 1px;
  }
  b {
    display: block;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  span,
  small {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  span {
    color: ${(p) => (p.$muted ? P.muted : P.ink)};
    text-decoration: ${(p) => (p.$struck ? 'line-through' : 'none')};
  }
  small {
    font-size: ${fs.xs}px;
    color: ${P.muted};
  }
`;

export const Agenda = styled.div`
  display: none;

  @container (max-width: ${AGENDA_BP}px) {
    display: grid;
    gap: 16px;
  }
`;

export const AgendaDay = styled.section`
  display: grid;
  gap: 8px;

  h3 {
    ${eyebrow}
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    color: ${(p) => (p.$today ? P.navy : P.subtle)};
  }
  h3 > span {
    font-family: ${fontSans};
    letter-spacing: 0;
    text-transform: none;
  }
`;

export const Empty = styled.p`
  margin: 0;
  padding: 28px 12px;
  text-align: center;
  font-size: ${fs.sm}px;
  color: ${P.subtle};
`;
